import React from "react";
import styled from "styled-components";
import { useLanguage } from "../contexts/LanguageContext";

const SkillsContainer = styled.div`
  padding: 50px;
  color: #727272;
  font-family: "Raleway", sans-serif;
`;

const BlockTitle = styled.h3`
  font-size: 20px;
  line-height: 26px;
  margin: 0 0 30px 0;
  font-weight: 500;
  text-transform: uppercase;
  color: #333;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
`;

const Col = styled.div<{ sm?: number }>`
  flex: ${(props) => (props.sm ? `0 0 ${(props.sm / 12) * 100}%` : "1")};
  padding: 0 15px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    flex: 0 0 100%;
  }
`;

const SkillCategory = styled.h4`
  font-size: 18px;
  margin: 0 0 20px 0;
  color: #333;
  text-transform: uppercase;
  font-weight: 700;
`;

const SkillsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    position: relative;
    padding: 8px 0 8px 25px;
    margin-bottom: 4px;
    line-height: 24px;

    &:before {
      content: "▸";
      color: #f34452;
      position: absolute;
      left: 0;
      font-weight: bold;
      font-size: 14px;
    }
  }
`;

const Skills: React.FC = () => {
  const { t } = useLanguage();

  const frontendBackendSkills = [
    "TypeScript / JavaScript (ES6+)",
    "React / Redux / React Flow",
    "Python / FastAPI / Pydantic",
    "Node.js / Express",
    "LLM app development (Anthropic Claude API)",
    "Prompt engineering & caching (RAG / CAG)",
    "Conversational & voice AI (ElevenLabs)",
    "D3.js / Data Visualization",
    "HTML5 / CSS3 / Sass",
    "Java",
    "REST APIs",
  ];

  const cloudInfraSkills = [
    "AWS (Lambda, EKS, Glue, Step Functions, S3)",
    "Serverless & IaC (AWS SAM, API Gateway)",
    "Kubernetes / Docker",
    "CI/CD (GitHub Actions, Jenkins)",
    "PostgreSQL / MySQL / MongoDB",
    "ETL / Data Pipelines",
    "Data Quality, Governance & SLAs",
    "AI Cost Optimization & Guardrails",
    "Distributed Systems",
    "System Design",
  ];

  const leadershipSkills = [
    "Engineering Management (IC to VP)",
    "Hiring & Team Building (0→5 engineers)",
    "OKRs / Goal-Setting",
    "Technical Roadmapping",
    "Agile / Scrum",
    "Cross-functional Collaboration",
    "Mentorship & Career Development",
    "Incident Review & On-call",
    "UI/UX Design",
    "Data Visualization",
  ];

  return (
    <SkillsContainer>
      <BlockTitle>{t("skills.title")}</BlockTitle>

      <Row>
        <Col sm={4}>
          <SkillCategory>{t("skills.technical")}</SkillCategory>
          <SkillsList>
            {frontendBackendSkills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </SkillsList>
        </Col>

        <Col sm={4}>
          <SkillCategory>{t("skills.cloud")}</SkillCategory>
          <SkillsList>
            {cloudInfraSkills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </SkillsList>
        </Col>

        <Col sm={4}>
          <SkillCategory>{t("skills.knowhow")}</SkillCategory>
          <SkillsList>
            {leadershipSkills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </SkillsList>
        </Col>
      </Row>
    </SkillsContainer>
  );
};

export default Skills;
